import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=7ca515f2&scoped=true&"
import script from "./Board.vue?vue&type=script&lang=js&"
export * from "./Board.vue?vue&type=script&lang=js&"
import style0 from "./Board.vue?vue&type=style&index=0&id=7ca515f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca515f2",
  null
  
)

export default component.exports